import { render, staticRenderFns } from "./imRecord.vue?vue&type=template&id=14623798"
import script from "./imRecord.vue?vue&type=script&lang=js"
export * from "./imRecord.vue?vue&type=script&lang=js"
import style0 from "./imRecord.vue?vue&type=style&index=0&id=14623798&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports